/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from './tslib.es6-e01eabb2.js';

/** 增强fail，具备errSuccessFormatOptions能力 */
function enhanceFail(fail, errFormatOptions) {
    if (fail === void 0) { fail = function (err) { return err; }; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    return function (e) {
        var formatOutput = errFormatOptions.formatOutput;
        var output = {};
        if (typeof formatOutput === 'function') {
            output = formatOutput(e);
        }
        output = __assign(__assign({}, e), output);
        fail === null || fail === void 0 ? void 0 : fail(__assign({ _originalErrInfo: e }, output));
    };
}
/** 增强success，具备formatOptions能力 */
function enhanceSuccess(success, enhanceInputParams, successFormatOptions, errFormatOptions) {
    if (success === void 0) { success = function (res) { return res; }; }
    if (enhanceInputParams === void 0) { enhanceInputParams = {
        success: noop,
        fail: noop,
    }; }
    if (successFormatOptions === void 0) { successFormatOptions = {}; }
    if (errFormatOptions === void 0) { errFormatOptions = {}; }
    var formatOutput = successFormatOptions.formatOutput;
    return function (ret) {
        // 容器成功调用，但错误码失败: 依然作为错误处理
        if (ret && ret.error) {
            var onFail = enhanceFail(enhanceInputParams && (enhanceInputParams === null || enhanceInputParams === void 0 ? void 0 : enhanceInputParams.fail), errFormatOptions);
            onFail(ret);
            return;
        }
        // 成功调用
        var output = {};
        if (typeof formatOutput === 'function') {
            output = formatOutput(ret);
        }
        output = __assign(__assign({}, ret), output);
        success === null || success === void 0 ? void 0 : success(__assign(__assign({}, output), { _original: {
                input: enhanceInputParams,
                output: ret,
            } }));
    };
}
/**
 * 容器适配层。抹平差异，使得输入和输出参数统一化。
 * 同时配合cn-uni-api的extend机制，call调用统一返回promise
 */
var adapterApiCall = function (args) {
    var apiName = args.apiName, params = args.params, JSCall = args.JSCall, _a = args.successFormatOptions, successFormatOptions = _a === void 0 ? {} : _a, _b = args.errFormatOptions, errFormatOptions = _b === void 0 ? {} : _b;
    var success = params.success, fail = params.fail;
    var formatInput = successFormatOptions.formatInput;
    // 入参format
    var extraParams = typeof formatInput === 'function' ? formatInput(params) : {};
    var enhanceInputParams = __assign(__assign({}, params), extraParams);
    // 出参format
    var onSuccess = enhanceSuccess(success, enhanceInputParams, successFormatOptions, errFormatOptions);
    var onFail = enhanceFail(fail, errFormatOptions);
    // 真正执行容器
    JSCall(apiName, enhanceInputParams, onSuccess, onFail);
};
// 空函数
var noop = function (opts) { return opts; };

export { adapterApiCall as a, noop as n };
